var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('v-select',{attrs:{"label":"Роль","items":_vm.roles,"value":_vm.value,"item-text":"roleName","item-value":"value"},on:{"change":_vm.onChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }